<div
  #itemLink
  class="item-link"
  (mouseenter)="onHover(true)"
  (mouseleave)="onHover(false)"
  *ngIf="module"
>
  <a
    *ngIf="module.link != ''; else noLink"
    [routerLink]="[module.link]"
    routerLinkActive="active"
    (click)="onClick($event)"
  >
    <div [class]="module.class"></div>
  </a>
  <ng-template #noLink>
    <a>
      <div [class]="module.class"></div>
    </a>
  </ng-template>
  <div
    #submenu
    class="sub-menu"
    [class]="module.child_class"
    *ngIf="module.children.length"
  >
    <div class="list-submenu">
      <div class="heading">
        <div class="title_">{{ module.title | translate }}</div>
      </div>
      <div class="items">
        <ng-container *ngFor="let child of module.children">
          <div class="item" *ngIf="child.access">
            <a
              (click)="onChildNavClick()"
              [routerLink]="[child.link]"
              routerLinkActive="active"
              *ngIf="child.link; else noLinkChild"
              >{{ child.title | translate }}</a
            >
            <ng-template #noLinkChild>
              <a>{{ child.title | translate }}</a>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
